import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function Nav({ onMyCouncil, onSearch, searchActive, councilActive }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleRecommendation = onMyCouncil ?? (() => navigate("/", { state: { panel: "council" } }));
  const handleSearch = onSearch ?? (() => navigate("/", { state: { panel: "search" } }));

  const closeMenu = () => setMenuOpen(false);

  const navItems = [
    {
      label: "Map",
      active: pathname === "/" && !searchActive && !councilActive,
      onClick: () => { navigate("/"); closeMenu(); },
    },
    {
      label: "Recommendation",
      active: councilActive,
      onClick: () => { handleRecommendation(); closeMenu(); },
    },
    {
      label: "Search",
      active: searchActive,
      onClick: () => { handleSearch(); closeMenu(); },
    },
    {
      label: "About",
      active: pathname === "/about",
      onClick: () => { navigate("/about"); closeMenu(); },
    },
  ];

  return (
    <>
      <nav className="app-nav">
        <button
          className="logo-btn"
          onClick={() => { navigate("/"); closeMenu(); }}
          style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
        >
          <span className="logo">Unloaned Books in London Libraries</span>
        </button>

        {/* Desktop nav buttons */}
        {navItems.map(({ label, active, onClick }) => (
          <button key={label} className={`nav-btn ${active ? "active" : ""}`} onClick={onClick}>
            {label}
          </button>
        ))}

        {/* Mobile hamburger */}
        <button
          className={`hamburger-btn ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label={menuOpen ? "Close menu" : "Open menu"}
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      {menuOpen && (
        <>
          <div className="mobile-menu-backdrop" onClick={closeMenu} />
          <nav className="mobile-menu">
            {navItems.map(({ label, active, onClick }) => (
              <button
                key={label}
                className={`mobile-menu-item ${active ? "active" : ""}`}
                onClick={onClick}
              >
                {label}
              </button>
            ))}
          </nav>
        </>
      )}
    </>
  );
}

export default Nav;
